/* eslint-disable react/no-unescaped-entities */
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

import Container from "~franchise-website/common/Container";

const CaseStudyOne = () => {
	const theme = useTheme();
	return (
		<Box
			borderRadius={1.5}
			sx={{
				position: "relative",
				backgroundColor: theme.palette.alternate.main,
				"&::after": {
					position: "absolute",
					content: '""',
					width: "30%",
					zIndex: 1,
					top: 0,
					right: 0,
					height: "100%",
					backgroundSize: "18px 18px",
					backgroundImage: `radial-gradient(${theme.palette.primary.light} 20%, transparent 20%)`,
					opacity: 0.2,
				},
			}}>
			<Container
				position="relative"
				zIndex={2}
				paddingX={{ xs: 2, sm: 6, md: 12 }}>
				<Box>
					<Typography
						sx={{
							textTransform: "uppercase",
							fontWeight: "medium",
						}}
						gutterBottom
						color="secondary"
						align="center">
						FUEL YOUR GROWTH STORY
					</Typography>
					<Typography
						variant="h3"
						gutterBottom
						align="center">
						<Box
							fontWeight={700}
							component="span">
							Leading brands are driving growth in their franchise business,
							right now.
						</Box>
					</Typography>

					<Box
						component={Typography}
						variant="h6"
						fontWeight={400}
						align="center"
						gutterBottom>
						&ldquo;Mango is a great tool to fast track the growth of your
						business.
						<br />
						Great support from Paul and the team, would highly recommend.&rdquo;
					</Box>
					<Box
						component="ul"
						display="flex"
						justifyContent="center"
						width="100%">
						<Box
							component={ListItem}
							disableGutters
							width="auto">
							<ListItemAvatar>
								<Avatar src="/new-mangomap-assets/images/raheem.jpeg" />
							</ListItemAvatar>
							<ListItemText
								primary="Raheem Hamilton"
								secondary="ANYTIME FITNESS"
							/>
						</Box>
					</Box>
				</Box>
			</Container>
		</Box>
	);
};

export default CaseStudyOne;
